import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const Wrapper = styled.section`
  margin-top: 24px;
  p {
    margin: 0;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    color: var(--section-color-primary-600-color, var(--color-primary-600));
    & + p {
      margin-top: 16px;
    }
  }
  label {
    display: block;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    color: var(--section-slate-color, var(--slate));
  }

  a {
    text-decoration: none;
  }

  dl {
    margin: 24px 0 0 0;
  }
  dt {
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 22px;
  }
`;

export const MonitorWrapper = styled.section`
  display: flex;
  flex-direction: row;
  label {
    margin-top: 8px;
    color: var(--section-granite-color, var(--granite));
  }

  a {
    text-decoration: none;
  }
`;

export const ButtonWrapper = styled.div`
  padding-left: 60px;
  position: absolute;
  top: 32px;
  right: 32px;
`;

export const SettingsLine = styled.dd<{ isActivate: boolean }>`
  position: relative;
  margin: 0 0 8px 0;
  padding: 0 0 0 21px;
  font-size: 14px;
  line-height: 24px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  opacity: ${props => (props.isActivate ? 1 : 0.5)};
  span {
    text-transform: capitalize;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
  svg {
    position: absolute;
    left: -3px;
    top: 1px;
    & > path {
      fill: ${props =>
        props.isActivate
          ? "#4786FF"
          : "var(--icon-ebony-light-fill,var(--ebony-light))"};
    }
  }
`;

export const Tag = styled.span`
  display: inline-block;
  margin: 0 4px 0 0;
  padding: 2px 4px;
  font-family: var(--ff-mono), monospace;
  font-size: 12px;
  line-height: 16px;
  background-color: var(
    --section-color-primary-100-background-color,
    var(--color-primary-100)
  );
  border-radius: 2px;
`;

export const RepoInfo = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  @media (min-width: ${breakpoints[3]}) {
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 100px;
  }

  & div > label {
  }

  & div > span {
    color: var(--section-ebony-color, var(--ebony));
    font-size: 14px;
  }
`;

export const EmailRecipient = styled.span`
  color: var(--section-color-primary-600-color, var(--color-primary-600));
`;
